var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppLoader'),_c(_vm.$route.meta.headerCmp || 'Header',_vm._b({tag:"component"},'component',_vm.$route.params,false)),_c('router-view'),_c('Footer',_vm._b({},'Footer',_vm.$route.params,false)),_c('ModalUi'),_c('Messages')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }